import { Statistics } from '../types/statistics'
import { apiService } from './api.service'

export class StatisticsService {
  async getStatistics(): Promise<Statistics> {
    try {
      const response = await apiService.get<Statistics>('/statistics/')
      return response.data
    } catch (error) {
      throw error
    }
  }
}

export const statisticsService = new StatisticsService()
